import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Apollo } from 'apollo-angular'
import {
    LocalesEnum,
    Maybe,
    NewsFragment,
    NewsItemQuery,
    NewsItemQueryService,
    NewsItemQueryVariables,
    NewsItemsQuery,
    NewsItemsQueryService,
    NewsItemsQueryVariables,
} from '@app-graphql/schema'

@Injectable({
    providedIn: 'root',
})
export class NewsService {

    constructor(
        private newsItemQueryService: NewsItemQueryService,
        private newsItemsQueryService: NewsItemsQueryService,
    ) {
    }

    public getNewsItem(input: NewsItemQueryVariables): Observable<Apollo.QueryResult<NewsItemQuery>> {
        return this.newsItemQueryService.fetch({ variables: input })
    }

    public getNewsItems(input: NewsItemsQueryVariables): Observable<Apollo.QueryResult<NewsItemsQuery>> {
        return this.newsItemsQueryService.fetch({ variables: input })
    }

    public getNewsBySlug(slug: string, locale: string): Observable<Maybe<NewsFragment> | undefined> {
        return this.getNewsItem({ slug: slug, locale: locale as LocalesEnum }).pipe(
            map((newsItem) => newsItem.data?.newsItem),
        )
    }
}
